module.exports = __webpack_public_path__ + "img/gouwu_pc.2c32a538.png";